"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamagedEventArgs = void 0;
const EventType_1 = require("../EventType");
class DamagedEventArgs {
    constructor(damagedBy, damage, fromCrit, fromDoT) {
        this.damagedBy = damagedBy;
        this.damage = damage;
        this.fromCrit = fromCrit;
        this.fromDoT = fromDoT;
        this.__type = EventType_1.EventType.Damaged;
        this.__typeName = "Damaged";
    }
}
exports.DamagedEventArgs = DamagedEventArgs;
